import axios from 'src/libs/axios';
import { QueryFunctionContext } from '@tanstack/react-query';

const getCompanyInfo = (args: QueryFunctionContext<any>) => {
  const [url, params] = args.queryKey;

  return axios({
    method: 'get',
    url,
    params,
  });
};

const getPublicCompanyInfo = (args: QueryFunctionContext<any>) => {
  const [url, params] = args.queryKey;

  return axios({
    method: 'get',
    url,
    params,
  });
};

export default { getCompanyInfo, getPublicCompanyInfo };
